import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useContext, useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { ModalContext } from "context/ModalContext";
import { LoginFormContext } from "context/LoginFormContext";
import { amenityList } from "Apis/amenity";
import { getAmenityById } from "Apis/amenity";
import { deleteAmenityById } from "Apis/amenity";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import banner from "../../../assets/images/placeholder.jpg";
import MDActionButton from "components/MDActionButton";
import colors from "assets/theme/base/colors";
import Imagepreview from "components/MDImagePreview";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import { updateAmenity } from "Apis/amenity";
import AminityForm from "./Form";
import { AmenityContext } from "context/AmenityContext";
import { Chip } from "@mui/material";

const Amenity = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    access,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
  } = useContext(LoginFormContext);
  const { setEditData } = useContext(AmenityContext);
  const [amenityData, setAmenityData] = useState([]);
  const { imageBorder } = colors;
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });
  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      setFilterLoader(false);
      let response = await getAmenityById(row.id);
      if (response?.status === 200) {
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }

    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this advertisement!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result?.isConfirmed) {
          let deleteResponse = await deleteAmenityById(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            amenityData?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            getAmenityList();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse?.data?.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse?.data?.message,
              open: true,
            });
          }
        }
      });
    }
  };

  const [filterVal, setFilterVal] = useState({
    name: "",
    is_active: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      name: filterVal.name,
      is_online_booking_available: filterVal?.is_online_booking_available?.value,
      is_active: filterVal?.is_active?.value,
    },
  };

  const getAmenityList = async (data) => {
    let response = await amenityList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setIsLoading(false);
      setAmenityData(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.AMENITY);
  }, [modules]);

  useEffect(() => {
    getAmenityList();
  }, [filterVal, defaultFilter]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Amenity Name",
        accessor: "name",
        // minWidth: "85px",
        sort: true,
        filterLabel: "Name",
        filterAccessor: "name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value, row }) => {
          const imageUrl = row?.original?.amenity_images?.[0]?.image;

          const [imgError, setImgError] = React.useState(false);

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {imageUrl && !imgError ? (
                <img
                  src={imageUrl}
                  alt="image"
                  onError={() => setImgError(true)}
                  onClick={() => handleImageClick(imageUrl)}
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    border: `1px solid ${imageBorder?.borderColor}`,
                    cursor: "pointer",
                  }}
                />
              ) : (
                <img
                  src={banner}
                  alt="image"
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "fill",
                    border: `1px solid ${imageBorder?.borderColor}`,
                  }}
                />
              )}
              <DefaultCell value={value ? value : "-"} />
            </div>
          );
        },
      },
      {
        Header: "Description",
        accessor: "description",
        minWidth: "85px",
        sort: false,
        Cell: ({ value }) => {
          if (!value) return "-";

          // Remove HTML tags to count/display plain text
          const plainText = value.replace(/<[^>]+>/g, "");

          const truncatedText =
            plainText.length > 50 ? `${plainText.substring(0, 50)}...` : plainText;

          return <div style={{ maxWidth: "400px" }}>{truncatedText}</div>;
        },
      },
      {
        Header: "Online Booking Available",
        accessor: "is_online_booking_available",
        minWidth: "85px",
        sort: false,
        filterLabel: "Online Booking Available",
        filterAccessor: "is_online_booking_available",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Yes", value: "1" },
          { label: "No", value: "0" },
        ],
        Cell: ({ value }) => (
          <div style={{ maxWidth: "400px" }}>
            {value === 1 ? (
              <Chip
                label="Yes"
                color="success"
                size="small"
                variant="outlined"
                sx={{ marginBottom: "4px", padding: "4px 8px" }}
              />
            ) : (
              <Chip
                label="No"
                color="error"
                size="small"
                variant="outlined"
                sx={{ marginBottom: "4px", padding: "4px 8px" }}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        // minWidth: "115px",
        sort: false,
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="amenities"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row?.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row?.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: amenityData,
  };

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <>
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="Add Amenity"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Amenity`}
          >
            <AminityForm getAmenityList={getAmenityList} />
          </MDModal>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            tableTitle="Amenity List"
            updateApi={updateAmenity}
            getDataList={getAmenityList}
            rowCount={rowCount}
            // isDraggable={true}
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
          {selectedImage && (
            <Imagepreview
              open={isImageModalOpen}
              onClose={() => setIsImageModalOpen(false)}
              imageUrl={selectedImage}
            />
          )}
        </>
      </DashboardLayout>
    )
  );
};

Amenity.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  getAmenityList: PropTypes.func,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default Amenity;
